export const TMP_EVENT_NAME = '_tmp_eventId'
export const TMP_EVENT_DOMAIN = '.houseofmath.com'
